import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Tooltip,
} from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin"; // Pin Icon
import LockIcon from "@mui/icons-material/Lock"; // Private Icon
import PublicIcon from "@mui/icons-material/Public"; // Public Icon

// Type definition for visibility options
type VisibilityType = "Private" | "Public";

// Interface for component props (if you need to pass props later)
interface PinPromptDropdownProps {
  onPin: (visibility: VisibilityType) => void;
  disabled?: boolean;
}

const PinPromptDropdown: React.FC<PinPromptDropdownProps> = ({
  onPin,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handlePinAction = (visibility: VisibilityType): void => {
    onPin(visibility);
    handleClose(); // Close the menu after action
  };

  return (
    <Box>
      <Tooltip key={"pin-tooltip"} title={"Pin Current Prompt"} placement="top">
        <Button
          id="pin-prompt-button"
          aria-controls={open ? "pin-prompt-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          // variant="outlined" // Or 'outlined' if you prefer a button style
          size="small"
          disabled={disabled}
          sx={{
            color: "primary.main",
            minWidth: "auto", 
          }}
        >
          <PushPinIcon />
        </Button>
      </Tooltip>
      <Menu
        id="pin-prompt-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "pin-prompt-button",
        }}
        // Ensures the menu opens below the button
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem onClick={() => handlePinAction("Private")}>
          <LockIcon sx={{ mr: 1, color: "text.secondary" }} fontSize="small" />
          Pin as Private
        </MenuItem>

        <MenuItem onClick={() => handlePinAction("Public")}>
          <PublicIcon
            sx={{ mr: 1, color: "text.secondary" }}
            fontSize="small"
          />
          Pin as Public
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default PinPromptDropdown;
